import { type ReactElement, useEffect, useState } from 'react';
import { getRootLayout } from '@/layout';
import { PRODUCT_HEADER_HEIGHT } from '@/shared/consts/productLayout.const';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { useIsSmallerThanTabletSm } from '@/shared/hooks/useIsSmallerThanTabletSm';
import { cn } from '@/utils/tailwind.util';
import { ProductBottomNavigation, ProductSidebar } from './ProductSidebar';
type ProductSidebarLayoutOptions = {
  /**
   * 모바일 하단 탭바(퀴즈 자료실·내 퀴즈·내 보드·내 클래스)를 숨긴다.
   * 자체 탭과 뒤로가기 동선을 가진 화면에서 탭바가 본문을 가리기만 할 때 쓴다.
   */
  hideMobileBottomNavigation?: boolean;
};
const ProductSidebarLayout = ({
  children,
  contentClassName,
  hideMobileBottomNavigation = false
}: {
  children: ReactElement;
  contentClassName?: string;
} & ProductSidebarLayoutOptions) => {
  const [isMounted, setIsMounted] = useState(false);
  const isSmallerThanTabletSm = useIsSmallerThanTabletSm();
  const isInExternalPlatform = useIsInExternalPlatform();
  const shouldShowSidebar = isMounted && !isSmallerThanTabletSm && !isInExternalPlatform;
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (isMounted && !shouldShowSidebar) {
    const showBottomNavigation = isSmallerThanTabletSm && !isInExternalPlatform && !hideMobileBottomNavigation;
    return <>
        <main className={cn('pt-md breakpoint-content-padding tablet-sm:pb-[80px] tablet-sm:pt-lg',
      // 하단 탭바 높이만큼 비워 두는 자리. 탭바를 숨기면 안전 영역만 남긴다.
      hideMobileBottomNavigation ? 'pb-[env(safe-area-inset-bottom)]' : 'pb-[calc(100px+env(safe-area-inset-bottom))]')}>
          {children}
        </main>
        {showBottomNavigation && <ProductBottomNavigation />}
      </>;
  }
  return <div className="flex w-full bg-default" data-sentry-component="ProductSidebarLayout" data-sentry-source-file="ProductSidebarLayout.tsx">
      <div className="flex w-full items-start bg-default">
        <ProductSidebar style={{
        top: PRODUCT_HEADER_HEIGHT
      }} data-sentry-element="ProductSidebar" data-sentry-source-file="ProductSidebarLayout.tsx" />
        <main className={cn('min-w-0 flex-1 py-[12px] pb-[80px] pl-[24px] pr-[40px]',
      // 자체 하단 패딩을 가진 페이지(예: ClassroomDetailLayout)는 'pb-0' 로 중복 제거.
      contentClassName)}>
          {children}
        </main>
      </div>
    </div>;
};
export function getProductSidebarLayout(page: ReactElement, contentClassName?: string, options?: ProductSidebarLayoutOptions) {
  return getRootLayout(<ProductSidebarLayout contentClassName={contentClassName} {...options}>
      {page}
    </ProductSidebarLayout>);
}